import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ServiceAutoComplete } from 'triider-components';
import logotipoPrincipal from '../../assets/img/logotipo-principal.svg';
import { Creators as FormCreators } from '../../store/ducks/serviceForm';
import { Creators as ServiceCreators } from '../../store/ducks/services';
import {
  Container, Logotipo, WelcomeUser, SearchContent, SearchHelp,
} from './styles';

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.triiderUser && state.auth.triiderUser.user);
  const companySource = useSelector(state => state.company.data.source);
  const companyId = useSelector(state => state.company.data.id);

  const addressUser = useSelector(
    state => state.auth.triiderUser && state.auth.triiderUser.address,
  );

  const getServicesByCity = (city) => {
    dispatch(ServiceCreators.getServicesByCityRequest(city));
  };

  const handleClick = (service) => {
    dispatch(FormCreators.openForm({
      isOpen: true,
      serviceId: service.id,
      company_id: companyId,
    }));
  };

  return (
    <Container>
      <Logotipo width="200" height="60" src={logotipoPrincipal} alt="logotipo Triider - polvo feliz em laranja" />
      {user && user.name && (
        <WelcomeUser>{`Olá, ${user && user.name}`}</WelcomeUser>
      )}
      <SearchContent>
        {addressUser ? (
          <ServiceAutoComplete
            isPartner
            source={companySource}
            onServiceSelected={handleClick}
            onCitySelected={getServicesByCity}
            initialCityObject={{
              id: addressUser.city_id ? addressUser.city_id : 1,
              name: addressUser.name ? addressUser.name : 'Porto Alegre',
              state_id: addressUser.state_id ? addressUser.state_id : 1,
              state_name: addressUser.state_name ? addressUser.state_name : 'Rio Grande do Sul',
              state_initials: addressUser.state_initials ? addressUser.state_initials : 'RS',
            }}
          />
        ) : (
          <ServiceAutoComplete
            isPartner
            source={companySource}
            onCitySelected={getServicesByCity}
            onServiceSelected={handleClick}
          />
        )}
      </SearchContent>
      <SearchHelp>
        Tente: eletricista, consertar vazamento, marido de aluguel, etc
      </SearchHelp>
    </Container>
  );
};

export default Header;
